<template>
  <div>
    <div v-if="editing || absentValue">
      <venue-creator v-if="creating" @cancelled="creating = false" @input="update($event)" />

      <ais-instant-search v-else index-name="venues" :search-client="searchClient">
        <ais-autocomplete :escape-html="true">
          <div class="relative" slot-scope="{ currentRefinement, indices, refine }">
            <basic-input
              label="Veranstaltungsort"
              type="search"
              autocomplete="off"
              @blur="refine('')"
              :value="currentRefinement"
              placeholder="Nach Veranstaltungsort suchen"
              @input="refine($event)"
            />

            <div
              v-if="currentRefinement"
              class="absolute w-full bg-white border z-10 rounded-b max-h-56 overflow-y-auto shadow"
            >
              <ul>
                <li
                  v-for="hit in indices[0].hits"
                  @mousedown.prevent
                  @click="update(hit)"
                  :key="hit.objectID"
                  class="py-2 px-4 flex items-center hover:bg-gray-100 cursor-pointer text-sm"
                >
                  <font-awesome-icon class="mr-2 text-gray-400 leading-6" icon="location" />
                  <ais-highlight
                    highlighted-tag-name="span"
                    class="mr-2 leading-6"
                    attribute="name"
                    :hit="hit"
                  />
                  <ais-highlight
                    highlighted-tag-name="span"
                    class="leading-6 text-gray-600"
                    attribute="city"
                    :hit="hit"
                  />
                </li>
                <div
                  v-if="!(indices[0].hits.length > 0)"
                  class="py-2 px-4 text-sm"
                >Keine Suchergebnisse für {{currentRefinement}}</div>
                <li
                  class="py-2 px-4 bg-green-100 hover:bg-green-200 cursor-pointer text-sm"
                  @mousedown.prevent
                  @click="creating = true"
                >
                  <font-awesome-icon class="mr-2 text-green-700 leading-6" icon="plus" />
                  <span
                    class="leading-6 font-semibold text-green-600"
                  >{{currentRefinement.replace(/^\w/, c => c.toUpperCase())}} neu anlegen</span>
                </li>
              </ul>
            </div>
          </div>
        </ais-autocomplete>
      </ais-instant-search>
    </div>

    <div v-else>
      <label class="mb-1 block text-sm font-medium leading-5 text-gray-700">Veranstaltungsort</label>
      <div class="rounded-md bg-gray-100 px-6 py-5 sm:flex sm:items-start sm:justify-between">
        <div class="sm:flex sm:items-start">
          <div>
            <div
              class="sm:text-sm leading-5 font-medium text-gray-900"
            >{{getChagesOrOriginal('name')}}</div>
            <div class="mt-1 text-sm leading-5 text-gray-600 sm:flex sm:items-center">
              <div>{{getChagesOrOriginal('street')}}, {{getChagesOrOriginal('zip_code')}} {{getChagesOrOriginal('city')}}</div>
            </div>
          </div>
        </div>
        <div class="mt-4 sm:mt-0 sm:ml-6 sm:flex-shrink-0">
          <span class="inline-flex rounded-md shadow-sm">
            <basic-button @click="edit()" color="white">Bearbeiten</basic-button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import algoliasearch from "algoliasearch/lite";
import BasicInput from "@/components/basic/Input";
import BasicButton from "@/components/basic/Button";
import VenueCreator from "@/components/VenueCreator";
import _has from "lodash/has";

import {
  AisInstantSearch,
  AisAutocomplete,
  AisSearchBox,
  AisHighlight
} from "vue-instantsearch";

export default {
  components: {
    AisInstantSearch,
    AisAutocomplete,
    AisSearchBox,
    AisHighlight,
    BasicInput,
    BasicButton,
    VenueCreator
  },

  props: ["value"],

  data() {
    return {
      searchClient: algoliasearch(
        "9F2932A63L",
        "cb1eef593e170f81ef4d87066905ec19"
      ),
      creating: false,
      editing: false,
      changes: null
    };
  },

  computed: {
    absentValue() {
      return !this.value && !this.changes;
    }
  },

  methods: {
    getChagesOrOriginal(property) {
      return _has(this.changes, property)
        ? this.changes[property]
        : this.value[property];
    },

    update(changes) {
      this.changes = changes;

      this.$emit("input", changes.id);
      this.editing = false;
    },

    edit() {
      this.editing = true;
      this.$emit("input", null);
    }
  }
};
</script>

<style>
.ais-Highlight-highlighted {
  @apply .font-semibold;
}
</style>